import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useCollective } from '../context/CollectiveContext';

const { FiMessageCircle } = FiIcons;

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

const LOGO_MAIN = "/mailbox-flyers.png";
const LOGO_SM   = "/mb-sm-logo.png";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const collective = useCollective();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-brand-cream shadow-xl h-16' : 'bg-transparent h-24'}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full relative">
          
          {/* Logo — full stacked on hero, horizontal compact on scroll */}
          <div className="relative z-50 self-start pt-2">
            <a href="#" className="block">
              {/* Main stacked logo — visible when at top */}
              <img
                src={LOGO_MAIN}
                alt="mailboxflyers logo"
                className={`transition-all duration-500 transform origin-top-left drop-shadow-2xl h-32 md:h-40 lg:h-48 ${isScrolled ? 'opacity-0 scale-90 pointer-events-none absolute' : 'opacity-100 scale-100'}`}
              />
              {/* Horizontal compact logo — visible when scrolled */}
              <img
                src={LOGO_SM}
                alt="mailboxflyers logo"
                className={`transition-all duration-500 transform origin-top-left drop-shadow-lg h-10 ${isScrolled ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none absolute'}`}
              />
            </a>
          </div>
          
          <div className="hidden md:flex items-center space-x-8 lg:space-x-12">
            {!collective && (
              <>
                <button onClick={() => scrollTo('how-it-works')} className={`text-xs lg:text-sm font-black uppercase tracking-[0.2em] hover:text-brand-blue transition-colors ${isScrolled ? 'text-brand-brown' : 'text-white'}`}>Process</button>
                <button onClick={() => scrollTo('reserve')} className={`text-xs lg:text-sm font-black uppercase tracking-[0.2em] hover:text-brand-blue transition-colors ${isScrolled ? 'text-brand-brown' : 'text-white'}`}>Availability</button>
                <button onClick={() => scrollTo('pricing')} className={`text-xs lg:text-sm font-black uppercase tracking-[0.2em] hover:text-brand-blue transition-colors ${isScrolled ? 'text-brand-brown' : 'text-white'}`}>Pricing</button>
                <Link to="/websites" className={`text-xs lg:text-sm font-black uppercase tracking-[0.2em] hover:text-brand-blue transition-colors ${isScrolled ? 'text-brand-brown' : 'text-white'}`}>Landing Page</Link>
              </>
            )}
            {collective && (
              <span className={`text-xs font-black uppercase tracking-widest px-3 py-1 rounded-full text-white ${isScrolled ? '' : 'opacity-80'}`} style={{ backgroundColor: collective.v.hex }}>
                {collective.v.label} · {collective.label}
              </span>
            )}
            <a
              href="https://www.facebook.com/thegyrohero"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-8 py-2.5 rounded-2xl text-sm font-black uppercase tracking-tight transition-all active:scale-95 shadow-lg border-2 ${
                isScrolled
                ? 'text-white border-transparent hover:opacity-90'
                : 'bg-white/10 text-white border-white/20 hover:bg-white/20 backdrop-blur-sm'
              }`}
              style={isScrolled ? { backgroundColor: collective ? collective.v.hex : undefined, borderColor: 'transparent' } : {}}
            >
              Message Sean
            </a>
          </div>

          {/* Mobile CTA */}
          <div className="md:hidden">
            <a href="https://www.facebook.com/thegyrohero" target="_blank" rel="noopener noreferrer" className="text-white p-3 rounded-xl shadow-lg flex items-center gap-2" style={{ backgroundColor: collective ? collective.v.hex : '#009FE3' }}>
              <SafeIcon icon={FiMessageCircle} className="text-xl" />
              <span className="text-[10px] font-black uppercase tracking-widest">Chat</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}